import React from "react";
import { Link } from "@mui/material";

export const english: {
  title: React.ReactNode;
  description: React.ReactNode;
}[] = [
  {
    title: "Data Controller",
    description: (
      <>
        The party responsible for data processing on this website (the
        "controller") in accordance with the General Data Protection Regulation
        (GDPR) is:{"\n"}
        Sven Badalyan{"\n"}
        Hohenstaufenstraße 60{"\n"}
        10781 Berlin, Germany{"\n"}
        Phone:{" "}
        <Link
          href={"tel:+491627344423"}
          color="textSecondary"
          sx={{
            cursor: "pointer",
          }}
        >
          +491627344423
        </Link>
        {"\n"}
        Email:{" "}
        <Link
          href={"mailto:contact@svenbadalyan.com"}
          sx={{
            cursor: "pointer",
          }}
        >
          contact@svenbadalyan.com
        </Link>
      </>
    ),
  },
  {
    title: "General Information and Mandatory Disclosures",
    description: (
      <>
        We take the protection of your personal data very seriously. We treat
        your personal data as confidential and in accordance with the statutory
        data protection regulations and this privacy policy.{"\n"}
        When you use this website, various personal data are collected. Personal
        data is any data with which you could be personally identified. This
        privacy policy explains what information we collect and what we use it
        for. It also explains how and for what purpose this happens.{"\n"}
        Please note that data transmitted via the internet (e.g., via email
        communication) may be subject to security breaches. Complete protection
        of your data from third-party access is not possible.{"\n"}
        SSL/TLS Encryption{"\n"}
        This site uses SSL or TLS encryption for security reasons and for the
        protection of the transmission of confidential content, such as
        inquiries you send to us as the site operator. You can recognize an
        encrypted connection in your browser's address line when it changes from
        "http://" to "https://" and the lock icon is displayed in your browser's
        address bar.
      </>
    ),
  },
  {
    title: "Your Rights as a Data Subject",
    description: (
      <>
        Within the framework of the applicable legal provisions, you have the
        right at any time to free information (access) about your stored
        personal data, its origin and recipients, and the purpose of the data
        processing, and, if applicable, a right to rectification, blocking, or
        erasure of this data.{"\n"}
        You also have the right to request the restriction of processing of your
        personal data and the right to data portability.{"\n"}
        Furthermore, you have the right to lodge a complaint with the competent
        supervisory authority.{"\n"}
        Right to Withdraw Your Consent to Data Processing{"\n"}
        Many data processing operations are only possible with your express
        consent. You can revoke your consent at any time. An informal email
        making this request is sufficient. The legality of the data processing
        carried out before the revocation remains unaffected by the revocation.
      </>
    ),
  },
  {
    title: "Data Collection on This Website",
    description: (
      <>
        a) Cookies{"\n"}
        Our website uses "cookies." Cookies are small text files that are stored
        on your computer and saved by your browser. They do not harm your
        computer and do not contain viruses. Cookies help make our website more
        user-friendly, efficient, and secure.{"\n"}
        Most of the cookies we use are so-called "session cookies." They are
        automatically deleted after your visit. Other cookies remain in your
        device's memory until you delete them. These cookies make it possible to
        recognize your browser when you next visit the site.{"\n"}
        Technically necessary cookies are stored on the basis of Art. 6 (1) (f)
        GDPR. The website operator has a legitimate interest in the storage of
        cookies for the technically error-free and optimized provision of its
        services. If other cookies (such as those for analyzing your surfing
        behavior) are stored, they are treated separately in this privacy policy
        and require your consent (Art. 6 (1) (a) GDPR).{"\n"}
        You can configure your browser to inform you about the use of cookies so
        that you can decide on a case-by-case basis whether to accept or reject
        a cookie. Alternatively, your browser can be configured to automatically
        accept cookies under certain conditions or to always reject them, or to
        automatically delete cookies when closing your browser. Disabling
        cookies may limit the functionality of this website.{"\n"}
        b) Server Log Files{"\n"}
        The website provider automatically collects and stores information in
        "server log files," which your browser automatically transmits to us.
        These are:{"\n"}• Browser type and browser version{"\n"}• Operating
        system used{"\n"}• Referrer URL{"\n"}• Hostname of the accessing
        computer{"\n"}• Time of the server request{"\n"}• IP address{"\n"}
        This data will not be combined with data from other sources. The basis
        for this data processing is Art. 6 (1) (f) GDPR. The website operator
        has a legitimate interest in the technically error-free presentation and
        security of their website, which requires the collection of server log
        files.{"\n"}
        c) Contact Form{"\n"}
        Should you send us questions via the contact form, we will collect the
        data entered on the form, including the contact details you provide
        (e.g., name, email address), to answer your question and any follow-up
        questions.{"\n"}
        The processing of this data is based on Art. 6 (1) (b) GDPR if your
        request is related to the performance of a contract or is necessary for
        the implementation of pre-contractual measures. In all other cases, the
        processing is based on our legitimate interest in the effective
        processing of the inquiries addressed to us (Art. 6 (1) (f) GDPR).{"\n"}
        We will retain the data you provide on the contact form until you
        request its deletion, revoke your consent for its storage, or the
        purpose for its storage no longer pertains (e.g., after fulfilling your
        request). Any mandatory statutory provisions, especially those regarding
        mandatory data retention periods, remain unaffected.{"\n"}
      </>
    ),
  },
  {
    title: "Newsletter",
    description: (
      <>
        If you would like to receive the newsletter offered on the website, we
        require a valid email address and your name. To subscribe to the
        newsletter, you must give your active and voluntary consent, for
        example, by ticking a corresponding checkbox next to the contact form.
        {"\n"}
        The processing of the data entered into the newsletter registration form
        is based exclusively on your consent (Art. 6 (1) (a) GDPR). To verify
        that you are the owner of the specified email address and agree to
        receive the newsletter, we generally use the so-called double opt-in
        procedure.{"\n"}
        You can revoke your consent to the storage of your data, your email
        address, and their use for sending the newsletter at any time, e.g., via
        the "unsubscribe" link in the newsletter or by sending us an informal
        message. The legality of the data processing operations already carried
        out remains unaffected by the revocation.{"\n"}
        The data provided when registering for the newsletter will be used to
        distribute the newsletter until you cancel your subscription, at which
        point the data will be deleted.{"\n"}
      </>
    ),
  },
];

export const german: {
  title: React.ReactNode;
  description: React.ReactNode;
}[] = [
  {
    title: "Verantwortlicher für die Datenverarbeitung",
    description: (
      <>
        Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und
        anderer nationaler Datenschutzgesetze ist:{"\n"}
        Sven Badalyan{"\n"}
        Hohenstaufenstraße 60{"\n"}
        10781 Berlin, Deutschland{"\n"}
        Tel.:{" "}
        <Link
          href={"tel:+491627344423"}
          color="textSecondary"
          sx={{
            cursor: "pointer",
          }}
        >
          +491627344423
        </Link>
        {"\n"}
        E-Mail:{" "}
        <Link
          href={"mailto:contact@svenbadalyan.com"}
          sx={{
            cursor: "pointer",
          }}
        >
          contact@svenbadalyan.com
        </Link>
      </>
    ),
  },
  {
    title: "Allgemeine Hinweise und Pflichtinformationen",
    description: (
      <>
        Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln
        Ihre personenbezogenen Daten vertraulich und entsprechend der
        gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
        {"\n"}
        Wenn Sie diese Website benutzen, werden verschiedene personenbezogene
        Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie
        persönlich identifiziert werden können. Die vorliegende
        Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir
        sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
        {"\n"}
        Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei
        der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
        lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
        möglich.{"\n"}
        SSL- bzw. TLS-Verschlüsselung{"\n"}
        Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
        vertraulicher Inhalte, wie zum Beispiel Anfragen, die Sie an uns als
        Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine
        verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des
        Browsers von „http://“ auf „https://“ wechselt und an dem Schloss-Symbol
        in Ihrer Browserzeile.
      </>
    ),
  },
  {
    title: "Ihre Rechte als betroffene Person",
    description: (
      <>
        Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
        das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
        personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
        Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder
        Löschung dieser Daten.{"\n"}
        Sie haben zudem das Recht, die Einschränkung der Verarbeitung Ihrer
        personenbezogenen Daten zu verlangen sowie das Recht auf
        Datenübertragbarkeit.{"\n"}
        Ferner steht Ihnen ein Beschwerderecht bei der zuständigen
        Aufsichtsbehörde zu.{"\n"}
        Widerruf Ihrer Einwilligung zur Datenverarbeitung{"\n"}
        Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
        Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
        jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an
        uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung
        bleibt vom Widerruf unberührt.
      </>
    ),
  },
  {
    title: "Datenerfassung auf dieser Website",
    description: (
      <>
        a) Cookies{"\n"}
        Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind
        kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr
        Browser speichert. Sie richten auf Ihrem Rechner keinen Schaden an und
        enthalten keine Viren. Cookies dienen dazu, unser Angebot
        nutzerfreundlicher, effektiver und sicherer zu machen.{"\n"}
        Die meisten der von uns verwendeten Cookies sind so genannte
        „Session-Cookies“. Sie werden nach Ende Ihres Besuchs automatisch
        gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie
        diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim
        nächsten Besuch wiederzuerkennen.{"\n"}
        Technisch notwendige Cookies werden auf Grundlage von Art. 6 Abs. 1 lit.
        f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse
        an der Speicherung von Cookies zur technisch fehlerfreien und
        optimierten Bereitstellung seiner Dienste. Sofern andere Cookies (z.B.
        Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden
        diese in dieser Datenschutzerklärung gesondert behandelt und bedürfen
        Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).{"\n"}
        Sie können Ihren Browser so einstellen, dass Sie über das Setzen von
        Cookies informiert werden und Cookies nur im Einzelfall erlauben, die
        Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie
        das automatische Löschen der Cookies beim Schließen des Browsers
        aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität
        dieser Website eingeschränkt sein{"\n"}
        b) Server-Log-Dateien{"\n"}
        Der Provider der Seiten erhebt und speichert automatisch Informationen
        in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns
        übermittelt. Dies sind{"\n"}• Browsertyp und Browserversion{"\n"}•
        verwendetes Betriebssystem{"\n"}• Referrer URL{"\n"}• Hostname des
        zugreifenden Rechners{"\n"}• Uhrzeit der Serveranfrage{"\n"}• IP-Adresse
        {"\n"}
        Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
        vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6
        Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse
        an der technisch fehlerfreien Darstellung und der Sicherheit seiner
        Website – hierzu müssen die Server-Log-Files erfasst werden.{"\n"}
        c) Kontaktformular{"\n"}
        Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
        Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen
        Kontaktdaten (z.B. Name, E-Mail-Adresse) zwecks Bearbeitung der Anfrage
        und für den Fall von Anschlussfragen bei uns gespeichert.{"\n"}
        Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
        lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
        zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
        erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf
        unserem berechtigten Interesse an der effektiven Bearbeitung der an uns
        gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).{"\n"}
        Ihre Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre
        Einwilligung zur Speicherung widerrufen oder der Zweck für die
        Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer
        Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere
        Aufbewahrungsfristen – bleiben unberührt.{"\n"}
      </>
    ),
  },
  {
    title: "Newsletter",
    description: (
      <>
        Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten,
        benötigen wir von Ihnen eine E-Mail-Adresse sowie Ihren Namen. Um den
        Newsletter zu abonnieren, müssen Sie Ihre aktive und freiwillige
        Einwilligung erteilen, beispielsweise durch das Anklicken einer
        entsprechenden Checkbox neben dem Kontaktformular.
        {"\n"}
        Die Verarbeitung der in das Newsletter-Anmeldeformular eingegebenen
        Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6
        Abs. 1 lit. a DSGVO). Zur Überprüfung, dass Sie der Inhaber der
        angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters
        einverstanden sind, verwenden wir in der Regel das sogenannte
        Double-Opt-In-Verfahren.{"\n"}
        Ihre erteilte Einwilligung zur Speicherung der Daten, der E-Mail-Adresse
        sowie deren Nutzung zum Versand des Newsletters können Sie jederzeit
        widerrufen, etwa über den „Austragen“-Link im Newsletter oder durch eine
        formlose Nachricht an uns. Die Rechtmäßigkeit der bereits erfolgten
        Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.{"\n"}
        Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten
        Daten werden von uns bis zu Ihrer Austragung aus dem Newsletter
        gespeichert und nach der Abbestellung des Newsletters gelöscht.{"\n"}
      </>
    ),
  },
];

export const privacyPolicyData = {
  us: {
    title: "Privacy Policy",
    updatedAt: "Last Updated: May 24, 2024",
    content: english,
  },
  de: {
    title: "Datenschutzerklärung",
    updatedAt: "Stand: 24. Mai 2024",
    content: german,
  },
};
